import { CONTRACT_MODAL_ACTION_TYPE } from "../actions-type";

const initialState = {
  contractModalData: {},
  contractOpenModal: false,
  contractModalLoading: false,
};

export const contractModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTRACT_MODAL_ACTION_TYPE.GET_CONTRACT_MODAL:
      return {
        ...state,
        contractModalData: action.payload.data,
        contractOpenModal: action.payload.openModal,
      };
    case CONTRACT_MODAL_ACTION_TYPE.CONTRACT_OPEN_MODAL:
      return {
        ...state,
        contractModalData: {},
        contractOpenModal: action.payload,
      };
    case CONTRACT_MODAL_ACTION_TYPE.CONTRACT_MODAL_LOADING:
      return {
        ...state,
        contractModalLoading: action.payload,
      };
    default:
      return state;
  }
};
